import { render, staticRenderFns } from "./busca-exped.vue?vue&type=template&id=59221dba"
import script from "./busca-exped.vue?vue&type=script&lang=js"
export * from "./busca-exped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports